// Essential first-day checklist items (bilingual), admin-editable — same
// get/subscribe/load/save/reset pattern as career paths, systems, and
// policy chapters, backed by the generic "checklist" settings key.

import { getAdminToken, getSetting, getPublic, putSetting } from "../lib/api";

export interface ChecklistItem {
  id: string;
  ar: string;
  en: string;
}

export const DEFAULT_CHECKLIST: ChecklistItem[] = [
  { id: "email", ar: "استلمت بريد الترحيب عبر Outlook", en: "I received the welcome email on Outlook" },
  { id: "teams", ar: "أستطيع فتح Teams والاطلاع على المحادثات", en: "I can open Teams and view conversations" },
  { id: "menatechr", ar: "أستطيع الدخول على نظام الموارد البشرية", en: "I can sign in to the HR system" },
  { id: "kadengate", ar: "أستطيع فتح Kaden Gate من المتصفح", en: "I can open Kaden Gate in my browser" },
  { id: "password", ar: "قمت بتغيير كلمة المرور المؤقتة", en: "I changed my temporary password" },
  { id: "mfa", ar: "فعّلت المصادقة الثنائية (MFA)", en: "I set up multi-factor authentication (MFA)" },
  { id: "device", ar: "جهاز العمل جاهز ومتصل بالشبكة", en: "My work device is ready and connected to the network" },
];

// --- Runtime store (admin can override via the "checklist" setting) ---
const CHECKLIST_CHANGED = "kd-checklist-changed";
let current: ChecklistItem[] = [...DEFAULT_CHECKLIST];

export function getChecklist(): ChecklistItem[] {
  return current;
}

export function subscribeChecklist(cb: () => void): () => void {
  window.addEventListener(CHECKLIST_CHANGED, cb);
  return () => window.removeEventListener(CHECKLIST_CHANGED, cb);
}

function emit() {
  try {
    window.dispatchEvent(new Event(CHECKLIST_CHANGED));
  } catch {
    /* ignore */
  }
}

/** Load any admin-configured checklist override (public read, or admin read when signed in). */
export async function loadChecklist(): Promise<void> {
  const res = getAdminToken() ? await getSetting<ChecklistItem[]>("checklist") : await getPublic<{ value?: ChecklistItem[] } | ChecklistItem[]>("checklist");
  const value = Array.isArray((res.data as any)?.value) ? (res.data as any).value : res.data;
  if (Array.isArray(value) && value.length > 0) current = value as ChecklistItem[];
  emit();
}

// --- Admin editing ---
export function newChecklistItem(): ChecklistItem {
  return { id: "", ar: "", en: "" };
}
export async function saveChecklist(items: ChecklistItem[]): Promise<{ ok: boolean; error?: string }> {
  current = items;
  emit();
  const res = await putSetting("checklist", items);
  return res.ok ? { ok: true } : { ok: false, error: res.error };
}
export function resetChecklist(): Promise<{ ok: boolean; error?: string }> {
  return saveChecklist([...DEFAULT_CHECKLIST]);
}
